
// import { DatePicker } from 'antd';
import React, { useState, useEffect } from 'react'
// import Select from 'react-select'
import Axios from 'axios';
import { API_BASE_URL, GET_INVOICE_PAYMENTS } from '../../../Config';
import PropTypes from 'prop-types';


const InvoicePaymentView = ({ INVObj }) => {
    
    const [userDataSession, setUserDataSession] = useState([]);
    const [loading, setLoading] = useState(false);
    
    const [viewPayments, setViewPayments] = useState([]);

    // #region Session userdetails
    useEffect(() => {
        const userDataString = sessionStorage.getItem("userData");
        if (userDataString) {
            const userData = JSON.parse(userDataString);
            setUserDataSession(userData);
            
        } else {
            console.log("User data not found in sessionStorage");
        }
    }, []);

    // #region Get Purchase req details
    useEffect(() => {
        if (userDataSession && userDataSession.OrgId && INVObj && INVObj.PurchaseId){
        setLoading(true);
          Axios.get(`${API_BASE_URL}${GET_INVOICE_PAYMENTS}?PurchaseId=${INVObj.PurchaseId}`)
            .then(response => {
                if (response.data.Status) {
                    setLoading(false);
                    setViewPayments(response.data.ResultData);
                    console.log(response.data.ResultData, 'payments data data..');
                } else {
                    setLoading(false);
                    console.error('Error fetching data:', response.data.Message);
                }
            })
            .catch(error => {
                setLoading(false);
                console.error('Error fetching data:', error);
            });
        }
    
    }, [userDataSession, INVObj]);

    // useEffect(() => {
    //     let totalDiscount = 0;
    //     let totalTaxAmt = 0;
    //     let totalMrp = 0;
    //     if (viewProducts && viewProducts.length > 0) {
    //         totalDiscount = viewProducts.reduce((acc, product) => acc + (product.DiscountAmount || 0), 0);
    //     }
    //     if (viewProducts && viewProducts.length > 0) {
    //         totalTaxAmt = viewProducts.reduce((acc, product) => acc + (product.TaxAmount || 0), 0);
    //     }
    //     if (viewProducts && viewProducts.length > 0) {
    //         totalMrp = viewProducts.reduce((acc, product) => acc + (product.Mrp || 0), 0);
    //     }
    //     setDiscountAmount(totalDiscount);
    //     setTaxAmount(totalTaxAmt);
    //     setTotalMRP(totalMrp);
    // }, [viewProducts]);
    
    
    return (
        <div>
            {/* Add Payemnt */}
            <div
                className="offcanvas offcanvas-end"
                tabIndex={-1}
                id="offcanvasRightInvViewPay"
                aria-labelledby="offcanvasRightLabel"
                style={{ minWidth: "40%" }}
            >
                <div className="offcanvas-header">
                    <h4 id="offcanvasRightLabel">View Payment History ({INVObj && INVObj.AutoGenTransactionNo ? `${INVObj.AutoGenTransactionNo}` : ''})</h4>
                    <button
                        type="button"
                        className="btn-close text-reset"
                        data-bs-dismiss="offcanvas"
                        aria-label="Close"
                    />
                </div> <hr/>
                <div className="offcanvas-body">
                    {loading ?
                        <p className='text-center'>Loading...</p>
                    : 
                        <form>
                            <div className="row mb-2 mt-2">
                                <div className="col-lg-12">
                                    <div className="modal-body-table">
                                        <div className="table-responsive">
                                            <table className="table  datanew">
                                                <thead>
                                                    <tr>
                                                        <th>#</th>
                                                        <th>Date</th>
                                                        <th>Amount</th>
                                                        <th>Payment Type</th>
                                                        <th>Card No</th>
                                                        <th>Mobile</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {viewPayments.length !== 0 ? viewPayments.map((item, index) => (
                                                        <tr key={index}>
                                                            <td>{index + 1}</td>
                                                            <td>{index + 1}</td>
                                                            <td className='text-success'>{item.PaidAmount}</td>
                                                            <td>{item.PaymentTypeName}</td>
                                                            <td>{item.CardNo}</td>
                                                            <td>{item.MobileNo}</td>
                                                        </tr>
                                                    )) : (
                                                        <tr>
                                                            <td colSpan="8" className="text-center">No Data available</td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                            <div className='d-flex justify-content-between mt-2'>
                                                {/* <p>Total Discount: <span className='fw-bold'>{discountAmount}</span></p>
                                                <p>Total Tax: <span className='fw-bold'>{taxAmount}</span></p>
                                                <p>Total Amount: <span className='fw-bold'>{totalMRP}</span></p> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="mt-auto d-flex justify-content-end p-3">
                                <button
                                    type="button"
                                    className="btn btn-cancel me-2"
                                    data-bs-dismiss="modal"
                                >
                                    Cancel
                                </button>
                            </div>
                        </form> 
                    }
                </div>
            </div>
        </div>
    )
}

InvoicePaymentView.propTypes = {
    INVObj: PropTypes.object.isRequired,
};

export default InvoicePaymentView
